export default {
    icon: "el-icon-picture-outline",
    title: '轮播图',
    name: 'swiperBg',
    timestamp: 1701312980959001,
    setUp: {
        'tabVal': 1
    },
    swiperConfig: {
        title: '最多可添加10张图片，建议宽度750px；鼠标拖拽左侧圆点可调整图片 顺序',
        maxList: 10,
        list: [
            {
                img: "SERVER_API" + "/images/decoration/banner_1.jpg",
                info: [
                    {
                        title: '标题',
                        value: '今日推荐',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/pages/extension/news_list/index',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            },
            {
                img: "SERVER_API" + "/images/decoration/banner_2.jpg",
                info: [
                    {
                        title: '标题',
                        value: '温馨提示',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: 'https://www.baidu.com',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            }
        ]
    },
    isShow: {
        title: '是否显示背景色',
        val: 0
    },
    bgColor: {
        title: '背景颜色(渐变)',
        default: [
            {
                item: '#F62C2C'
            },
            {
                item: '#F96E29'
            }
        ],
        color: [
            {
                item: 'rgba(29,176,252,1)'
            },
            {
                item: 'rgba(64,209,244,1)'
            }
        ]
    },
    dotColor: {
        title: '指示器颜色',
        default: [
            {
                item: '#fff'
            }
        ],
        color: [
            {
                item: 'rgba(29,176,252,1)'
            }
        ]
    },
    bgStyle: {
        title: "背景样式",
        name: "bgStyle",
        type: 1,
        list: [
            {
                val: "直角",
                icon: "el-icon-edit-outline"
            },
            {
                val: "圆角",
                icon: "el-icon-c-scale-to-original"
            }
        ]
    },
    lrConfig: {
        title: '左右边距',
        val: 11,
        min: 0
    },
    mbConfig: {
        title: '页面间距',
        val: 10,
        min: 0
    },
    docConfig: {
        cname: 'swiper',
        title: '指示器样式',
        type: 0,
        list: [
            {
                val: '圆形',
                icon: 'iconDot'
            },
            {
                val: '直线',
                icon: 'iconSquarepoint'
            },
            {
                val: '数字',
                icon: 'iconshuzi'
            },
            {
                val: '无指示器',
                icon: 'iconjinyong'
            }
        ]
    },
    txtStyle: {
        title: '指示器位置',
        type: 2,
        list: [
            {
                val: '居左',
                icon: 'icondoc_left'
            },
            {
                val: '居中',
                icon: 'icondoc_center'
            },
            {
                val: '居右',
                icon: 'icondoc_right'
            }
        ]
    },
    imgConfig: {
        cname: 'docStyle',
        title: '轮播图样式',
        type: 0,
        list: [
            {
                val: '圆角',
                icon: 'iconPic_fillet'
            },
            {
                val: '直角',
                icon: 'iconPic_square'
            }
        ]
    },
    id: 'id1665385357481001'
};